<div>
    <rn-progress-tabs [tabs]="statusTabs" [selectedTabId]="tabSelected" [clickable]="isClickable()" (tabClicked)="tabClicked($event)"></rn-progress-tabs>
    <router-outlet></router-outlet>
  </div>